import { extent, geoAlbersUsa, geoPath, scaleLog, select } from 'd3'
import produce from 'immer'
import { map, values } from 'lodash'

import './render-map.scss'
import geo from './us-states.json'

const defaultColor = '#eee'
const COLOR_RANGE = ['#DEF2FA', '#47B2DD']

const margin = {
  top: 20,
  bottom: 20,
  left: 20,
  right: 20,
}
// gut feeling only
const ASPECT_RATIO_MAGIC_NUMBER = 0.6

export default (node, data, onStateSelect, onStateHover) => {
  const { width } = node.getBoundingClientRect()
  const height = width * ASPECT_RATIO_MAGIC_NUMBER

  const projection = geoAlbersUsa().fitSize(
    [width - margin.left - margin.right, height - margin.top - margin.bottom],
    geo,
  )

  const path = geoPath().projection(projection)

  const colorScale = scaleLog()
    .domain(extent(values(data)))
    .range(COLOR_RANGE)

  const features = map(geo.features, (g) =>
    produce(g, (feat) => {
      if (feat.properties.abbr) {
        feat.properties.count = data[feat.properties.abbr]
      }
    }),
  )

  const svg = select(node).attr('height', height)

  const g = svg
    .selectAll('.map-graph')
    .data([1])
    .join('g')
    .attr('class', 'map-graph audience-map-geo-comp')
    .style('transform', `translate(${margin.left}px, ${margin.top}px)`)

  const paths = g.selectAll('path').data(features, (d) => d.id)

  paths
    .enter()
    .append('path')
    .attr('class', 'state-path')
    .style('fill', defaultColor)
    .merge(paths)
    .attr('d', path)
    .style('fill', (d) => {
      if (d.properties.count > 0) {
        return colorScale(d.properties.count)
      }
      return defaultColor
    })
    .on('click', (d) => {
      const { abbr } = d.properties
      if (abbr) {
        onStateSelect(abbr)
      }
    })
    .each(function (d) {
      let openTo, closeTo
      select(this)
        .on('mouseover', () => {
          if (!d.properties.abbr) {
            return
          }
          clearTimeout(closeTo)
          openTo = setTimeout(() => {
            onStateHover({
              name: d.properties.name,
              count: d.properties.count,
              select: () => this,
            })
          }, 300)
        })
        .on('mouseout', () => {
          clearTimeout(openTo)
          closeTo = setTimeout(() => {
            onStateHover()
          }, 100)
        })
    })
}
